module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT1"
  }, [_c('span', {
    attrs: {
      "aria-label": "6",
      "id": "pg_6",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("Preparing your Zero Waste Kitchen")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fbm-quote"
  }, [_c('span', {
    staticClass: "serif"
  }, [_vm._v("The kitchen is the busiest, most hard-working room in the house. It encompasses cooking, cleaning, shopping, eating, washing, living and growing. This little book couldn’t possibly cover all of those things, so when we sat down to talk about what we wanted to share, we knew it would be how we use craft as part of our toolkit to reduce waste and live more sustainably.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Becoming confident with a glue gun, getting to grips with a sewing machine, knowing how to work a blanket stitch or even learning the basics of crochet are all really important skills that will help you to reimagine what waste materials can be. They allow you to transform a milk bottle into a cutlery caddy (packed lunches are an amazing quick win when it comes to reducing waste!), or make your own beeswax wraps. The more you craft, the more confident you become and the more opportunities you see in the things")]), _vm._v(" "), _c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("around you.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("The other reason we wanted to focus on crafting instead of cooking or cleaning is that it’s important to remember that crafting takes time. It’s convenience that got us into this mess and crafting is a great way to reset that mindset. Crafting helps us to slow down, connects the head with the hands, and brings all sorts of benefits, not just to our wellbeing but to the planet. Adding a bit of hand sewing to your day instead of shopping online does wonders for the soul and develops a skill that can be used time and again.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("This book then is about ways to remake things to help you in the kitchen. These are craft projects that can reduce the packaging coming out of your kitchen, and reuse things from around the house to reduce packaging going into your kitchen. They are here to inspire you to rethink the possibilities of waste, and of materials, and help you to build all the skills you need to live a zero waste lifestyle.")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('samp', {
    staticClass: "SANS_Milliard_ExtraLight_229"
  }, [_vm._v("Making this book has been a pleasure and a delight. Emma says, ‘When Christine suggested I have a go at making reusable popcorn bags I was so over-excited by having made popcorn in a fabric bag that I had to send her pictures!’ We hope you enjoy it as much as we did and take as much delight in the surprises to be found in remaking things.")])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG-BRK"
  }, [_c('span', {
    attrs: {
      "aria-label": "7",
      "id": "pg_7",
      "role": "doc-pagebreak"
    }
  }, [_c('img', {
    staticClass: "img100",
    attrs: {
      "alt": "",
      "src": "images/pg7.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45eeec02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preparing.vue
// module id = 72
// module chunks = 0